import userMixin from "@/components/mixins/userMixin";
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import localStorageMixin from "@/components/mixins/localStorageMixin";
import {checkIfUserHasRole} from "@/core/utils/helpers/checkIfUserHasRole";
import {isEscortAvailableToday} from "@/core/utils/helpers/users/escort/escortHelpers";

function trackEvent(category, action, label) {
    this.captureTrackingEvent(this.currentUser, category, action, label, this.user.id);
}

function onCallClick(phone) {
    const clickTime = this.moment().format();
    const payload = {
        time: clickTime,
        user: {
            id: this.user.id,
            username: this.user.username
        },
    };
    this.setLocalStorageObject(this.escortCallFeedbackKey, payload);

    window.location.href = `tel:${phone}`;
}

function reportProfile() {
    this.trackEvent('profile', 'report', 'click');
    $('#modalReportProfile').modal('show');
}

function fetchUser() {
    this.$emit('fetchUser')
}

function configureMap() {
    if (typeof document === "undefined") {
        return;
    }

    const mapElement = document.querySelector('#map');

    if (mapElement && this.getMapHolder && this.areUserCoordinatesSet && typeof L !== 'undefined' && !this.mapLoaded) {
        this.mapObject = L.map('map', {
            center: [this.user.lat, this.user.lon],
            zoom: this.map.zoom
        });

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.mapObject);

        const markerIcon = L.icon({
            iconUrl: '/images/map/map-marker.png',
            iconSize: [48, 48],
            iconAnchor: [16, 32],
        });

        L.marker(
            [this.user.lat, this.user.lon],
            {icon: markerIcon}
        ).addTo(this.mapObject);

        this.mapLoaded = true;
    }
}

function showModalBlurredProfile() {
    const ref = _.get(this, '$refs.modalBlurredProfile');

    if (ref) {
        ref.openModal();
    }
}

function isFullyScrolledInView() {
    const actions = document.getElementById("profile-page-actions");
    const positionElement = document.getElementById("profile-page-actions-position");

    if (!actions || !positionElement) return;

    const positionRect = positionElement.getBoundingClientRect();

    if (positionRect.top < window.innerHeight) {
        actions.classList.add("sticky");
    } else {
        actions.classList.remove("sticky");
    }
}

export default {
    data() {
        return {
            store: $store,
            moment: moment,
        }
    },
    computed: {
        ...mapState(['translate', 'currentUser', 'settings']),
        blurLockedProfile() {
            if (typeof hasCookieConsentSet === "undefined" || !hasCookieConsentSet()) {
                return false;
            }

            if (this.isGoldUser(this.user) || this.isSilverUser(this.user)) {
                return false;
            }

            if (isEscortAvailableToday(this.user)) {
                return false;
            }

            if (_.get(this, 'user.is_locked', false) && !this.currentUser) {
                return true;
            }

            // using !! coz in JS '0 && null' returns '0' instead of 'false'
            return !!(_.get(this, 'user.is_blurred', false) && !this.currentUser)
        },
        isVenueProfile() {
            return checkIfUserHasRole(constants.user_role.VENUE, this.user);
        },
        isNewProfile() {
            const firstPublished = this.user.first_listed_date;
            if (!firstPublished) {
                return false;
            }
            const expiresValue = this.settings.recent_profile_expires_value;
            const expiresUnit = this.settings.recent_profile_expires_unit;
            const expiryDate = this.moment(firstPublished).add(expiresValue, expiresUnit);
            return expiryDate.isAfter(this.moment());
        },
        showFavoriteIcon() {
            return !this.isSeekingServicesProfile && (!this.isLoggedIn || this.isPunter)
        },
        profileIsInactive() {
            const lastOnline = _.get(this, 'user.contactable');
            return this.moment().isAfter(this.moment(lastOnline).add(2, 'months'));
        },
        areUserCoordinatesSet() {
            const lat = _.get(this, 'user.lat', -999);
            const lon = _.get(this, 'user.lon', -999);
            return (
                lat != null
                && lon != null
                && lat >= -90
                && lat <= 90
                && lon >= -180
                && lon <= 180
            );
        },
        showOutcallLocation() {
            if (!this.user) {
                return false;
            }

            if (_.get(this, 'user.meeting_location', 0) < 1) {
                return false;
            }

            const userCanHaveOutcalls = this.isGoldUser(this.user)
                || _.get(this, 'user.userCanHaveOutcallsForFree')
                || _.get(this, 'settings.outcallLocations.maxFreeAmount', 0) > 0

            if (!userCanHaveOutcalls) {
                return false;
            }

            return (_.get(this, 'user.outcall_locations_list.length', 0) > 0
                || _.get(this, 'user.escorts_profile.outcall_location_info.length', 0) > 0
            );
        },
        currentUserIsProfileUser() {
            const profileUserId = _.get(this, 'user.id', null)
            const currentUserId = _.get(this, 'currentUser.id', null)
            return profileUserId === currentUserId
        },
        isBlurred() {
            return _.get(this, 'user.is_blurred', false)
        },
        isLocked() {
            return _.get(this, 'user.is_locked', false)
        },
        isGoldOrSilver() {
            return this.isGoldUser(this.user) || this.isSilverUser(this.user)
        },
        profileUserIsCurrentUserAndBlurred() {
            return (this.isBlurred || this.isLocked) && this.currentUserIsProfileUser && !this.isGoldOrSilver && !isEscortAvailableToday(this.user)
        },
        outcallLocationsForAdmin() {
            return _.get(this, 'user.outcall_locations_list.length')
                ? this.user.outcall_locations_list.map((outcallLocation) => outcallLocation.name).join('; ')
                : 'no outcall locations selected';
        },
    },
    mixins: [userMixin, xtrackingMixin, localStorageMixin],
    methods: {
        trackEvent,
        onCallClick,
        reportProfile,
        fetchUser,
        configureMap,
        showModalBlurredProfile,
        isFullyScrolledInView,
    }
}
